class LeadgenTimer {
    constructor(element) {
        this.element = element;
        this.timerDate = new Date(this.element.dataset.timerDate).getTime();
        this.daysElement = this.element.querySelector('[data-days]');
        this.hoursElement = this.element.querySelector('[data-hours]');
        this.minutesElement = this.element.querySelector('[data-minutes]');
        this.secondsElement = this.element.querySelector('[data-seconds]');

        this.updateTimer();
        setInterval(() => this.updateTimer(), 1000);
    }

    updateTimer() {
        const now = new Date().getTime();
        const distance = this.timerDate - now;

        if (distance < 0) {
            this.element.innerHTML = "EXPIRED";
            return;
        }

        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        this.daysElement.textContent = String(days).padStart(2, '0');
        this.hoursElement.textContent = String(hours).padStart(2, '0');
        this.minutesElement.textContent = String(minutes).padStart(2, '0');
        this.secondsElement.textContent = String(seconds).padStart(2, '0');
    }
}

// Initialize all timers on the page
document.addEventListener('DOMContentLoaded', () => {
    const timers = document.querySelectorAll('.leadgen__card--timer');
    timers.forEach(timer => new LeadgenTimer(timer));
});